"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwSpecCompositorTemplateSlot = exports.UwSpecCompositorTemplateName = void 0;
/**
 * UW Spec Compositor Template Names
 *
 * Diagnostic labels retained in compositor provenance. DM configuration also uses
 * this vocabulary for DM-local slots; selection always resolves a namespace/slot key.
 *
 * @TranslateToPython
 */
var UwSpecCompositorTemplateName;
(function (UwSpecCompositorTemplateName) {
    UwSpecCompositorTemplateName["homeDefault"] = "homeDefault";
    UwSpecCompositorTemplateName["homeRecommendedPolicies"] = "homeRecommendedPolicies";
    UwSpecCompositorTemplateName["homeUpgradeMoap"] = "homeUpgradeMoap";
    UwSpecCompositorTemplateName["homeUpgradeAvenCash"] = "homeUpgradeAvenCash";
    UwSpecCompositorTemplateName["homeUpgradeHelocRefi"] = "homeUpgradeHelocRefi";
    UwSpecCompositorTemplateName["homeUpgradeFirstLienRefi"] = "homeUpgradeFirstLienRefi";
    UwSpecCompositorTemplateName["homeFirstLienAndMortgage"] = "homeFirstLienAndMortgage";
    UwSpecCompositorTemplateName["homeFirstLienHelocPurchase"] = "homeFirstLienHelocPurchase";
    UwSpecCompositorTemplateName["homeFirstLienHelocRefi"] = "homeFirstLienHelocRefi";
    UwSpecCompositorTemplateName["homePrequalSlider"] = "homePrequalSlider";
    UwSpecCompositorTemplateName["homeAvenCashNonAtpSlider"] = "homeAvenCashNonAtpSlider";
    UwSpecCompositorTemplateName["defaultDigitalAvenCash"] = "defaultDigitalAvenCash";
    UwSpecCompositorTemplateName["digitalAvenCashCltvPricing"] = "digitalAvenCashCltvPricing";
    UwSpecCompositorTemplateName["digitalMoapCltvPricing"] = "digitalMoapCltvPricing";
    UwSpecCompositorTemplateName["homeAvenCashNonAtpMegaLineSlider"] = "homeAvenCashNonAtpMegaLineSlider";
    UwSpecCompositorTemplateName["homeMoapSlider"] = "homeMoapSlider";
    UwSpecCompositorTemplateName["homeAtpSlider"] = "homeAtpSlider";
    UwSpecCompositorTemplateName["homeInternalMloAtpSlider"] = "homeInternalMloAtpSlider";
    UwSpecCompositorTemplateName["homeMloCrmSlider"] = "homeMloCrmSlider";
    UwSpecCompositorTemplateName["homeCreditKarmaAtpSlider"] = "homeCreditKarmaAtpSlider";
    UwSpecCompositorTemplateName["homeCreditKarmaTuPricedAtpSlider"] = "homeCreditKarmaTuPricedAtpSlider";
    UwSpecCompositorTemplateName["homeAtpGenericPartnerSlider"] = "homeAtpGenericPartnerSlider";
    UwSpecCompositorTemplateName["homeTexasRecommendedPolicies"] = "homeTexasRecommendedPolicies";
    UwSpecCompositorTemplateName["texasAvenCashDM"] = "texasAvenCashDM";
    UwSpecCompositorTemplateName["avenCashDmSlider"] = "avenCashDmSlider";
    UwSpecCompositorTemplateName["defaultDmAvenCash"] = "defaultDmAvenCash";
    UwSpecCompositorTemplateName["post2026OctAvenCashDM"] = "post2026OctAvenCashDM";
    UwSpecCompositorTemplateName["post2026OctMoapDM"] = "post2026OctMoapDM";
    UwSpecCompositorTemplateName["uccDefault"] = "uccDefault";
    UwSpecCompositorTemplateName["uccUpgradeBasic"] = "uccUpgradeBasic";
    UwSpecCompositorTemplateName["uccUpgradeFixedTerm"] = "uccUpgradeFixedTerm";
    UwSpecCompositorTemplateName["uccRewardsUpgradeToHome"] = "uccRewardsUpgradeToHome";
    UwSpecCompositorTemplateName["mortgageDefault"] = "mortgageDefault";
    UwSpecCompositorTemplateName["depositDefault"] = "depositDefault";
    UwSpecCompositorTemplateName["unknownDefault"] = "unknownDefault";
    UwSpecCompositorTemplateName["advisorDefault"] = "advisorDefault";
    UwSpecCompositorTemplateName["cryptoDefault"] = "cryptoDefault";
    UwSpecCompositorTemplateName["flexAndHomeFixedTerm"] = "flexAndHomeFixedTerm";
    UwSpecCompositorTemplateName["homeUpgradeMoapToAvenCash"] = "homeUpgradeMoapToAvenCash";
    UwSpecCompositorTemplateName["homeDefaultMoapAndMortgage"] = "homeDefaultMoapAndMortgage";
    UwSpecCompositorTemplateName["homeDefaultMoap"] = "homeDefaultMoap";
    UwSpecCompositorTemplateName["homeDefaultAvenCash"] = "homeDefaultAvenCash";
    UwSpecCompositorTemplateName["homeAvenCashUpgradeToFirstLienRefi"] = "homeAvenCashUpgradeToFirstLienRefi";
    UwSpecCompositorTemplateName["uccDefaultRewards"] = "uccDefaultRewards";
    UwSpecCompositorTemplateName["uccDefaultFlex"] = "uccDefaultFlex";
})(UwSpecCompositorTemplateName || (exports.UwSpecCompositorTemplateName = UwSpecCompositorTemplateName = {}));
/**
 * Product-local template slot identifiers.
 *
 * These are the keys used in PRODUCT_TEMPLATES[product].templates[slot].
 * Combined with a product, they form the globally unique template registry key (e.g., "HOME:upgradeMoap").
 *
 * @TranslateToPython
 */
var UwSpecCompositorTemplateSlot;
(function (UwSpecCompositorTemplateSlot) {
    UwSpecCompositorTemplateSlot["Default"] = "default";
    UwSpecCompositorTemplateSlot["HomeRecommendedPolicies"] = "recommendedPolicies";
    UwSpecCompositorTemplateSlot["HomeUpgradeMoap"] = "upgradeMoap";
    UwSpecCompositorTemplateSlot["HomeUpgradeAvenCash"] = "upgradeAvenCash";
    UwSpecCompositorTemplateSlot["HomeUpgradeHelocRefi"] = "upgradeHelocRefi";
    UwSpecCompositorTemplateSlot["HomeUpgradeFirstLienRefi"] = "upgradeFirstLienRefi";
    UwSpecCompositorTemplateSlot["HomeFirstLienAndMortgage"] = "firstLienAndMortgage";
    UwSpecCompositorTemplateSlot["HomeFirstLienHelocPurchase"] = "firstLienHelocPurchase";
    UwSpecCompositorTemplateSlot["HomeFirstLienHelocRefi"] = "firstLienHelocRefi";
    UwSpecCompositorTemplateSlot["HomePrequalSlider"] = "prequalSlider";
    UwSpecCompositorTemplateSlot["HomeAvenCashNonAtpSlider"] = "avenCashNonAtpSlider";
    UwSpecCompositorTemplateSlot["HomeDefaultDigitalAvenCash"] = "defaultDigitalAvenCash";
    UwSpecCompositorTemplateSlot["HomeDigitalAvenCashCltvPricing"] = "digitalAvenCashCltvPricing";
    UwSpecCompositorTemplateSlot["HomeDigitalMoapCltvPricing"] = "digitalMoapCltvPricing";
    UwSpecCompositorTemplateSlot["HomeAvenCashNonAtpMegaLineSlider"] = "avenCashNonAtpMegaLineSlider";
    UwSpecCompositorTemplateSlot["HomeMoapSlider"] = "moapSlider";
    UwSpecCompositorTemplateSlot["HomeAtpSlider"] = "atpSlider";
    UwSpecCompositorTemplateSlot["HomeInternalMloAtpSlider"] = "internalMloAtpSlider";
    UwSpecCompositorTemplateSlot["HomeMloCrmSlider"] = "mloCrmSlider";
    UwSpecCompositorTemplateSlot["HomeCreditKarmaAtpSlider"] = "creditKarmaAtpSlider";
    UwSpecCompositorTemplateSlot["HomeCreditKarmaTuPricedAtpSlider"] = "creditKarmaTuPricedAtpSlider";
    UwSpecCompositorTemplateSlot["HomeAtpGenericPartnerSlider"] = "atpGenericPartnerSlider";
    UwSpecCompositorTemplateSlot["HomeTexasRecommendedPolicies"] = "texasRecommendedPolicies";
    UwSpecCompositorTemplateSlot["UccUpgradeBasic"] = "upgradeBasic";
    UwSpecCompositorTemplateSlot["UccUpgradeFixedTerm"] = "upgradeFixedTerm";
    UwSpecCompositorTemplateSlot["UccRewardsUpgradeToHome"] = "rewardsUpgradeToHome";
    UwSpecCompositorTemplateSlot["FlexAndHomeFixedTerm"] = "flexAndHomeFixedTerm";
    UwSpecCompositorTemplateSlot["HomeUpgradeMoapToAvenCash"] = "homeUpgradeMoapToAvenCash";
    UwSpecCompositorTemplateSlot["HomeDefaultMoapAndMortgage"] = "defaultMoapAndMortgage";
    UwSpecCompositorTemplateSlot["HomeDefaultMoap"] = "defaultMoap";
    UwSpecCompositorTemplateSlot["HomeDefaultAvenCash"] = "defaultAvenCash";
    UwSpecCompositorTemplateSlot["HomeAvenCashUpgradeToFirstLienRefi"] = "avenCashUpgradeToFirstLienRefi";
    UwSpecCompositorTemplateSlot["UccDefaultRewards"] = "defaultRewards";
    UwSpecCompositorTemplateSlot["UccDefaultFlex"] = "defaultFlex";
})(UwSpecCompositorTemplateSlot || (exports.UwSpecCompositorTemplateSlot = UwSpecCompositorTemplateSlot = {}));
